// extracted by mini-css-extract-plugin
export default {"svgObjects":"styles_svgObjects__m8Sog","imagePalm":"styles_imagePalm__Dm8Cu"};